module.exports = __webpack_public_path__ + "img/icon_2.ff933ccc.png";